import { rgb as rgbContrast } from 'wcag-contrast';

import { UnityColor } from '@lifeserver/shared';

const getWcagContrast = (background: UnityColor, text: UnityColor) => {
    return rgbContrast(
        [text.r * 255, text.g * 255, text.b * 255],
        [background.r * 255, background.g * 255, background.b * 255],
    );
};

export const getBestContrast = (
    backgroundColor: UnityColor,
    textColorAlternatives: UnityColor[],
) => {
    const alternativeWithContrast = textColorAlternatives.map((textColor) => ({
        color: textColor,
        contrast: getWcagContrast(backgroundColor, textColor),
    }));

    const first = alternativeWithContrast[0];

    return alternativeWithContrast.reduce(
        (next, current) => (current.contrast > next.contrast ? current : next),
        first,
    ).color;
};
